import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from 'constants/gateway';

const { C300 } = GW_SERVICES_PREFIXES;

/* Получение всех возможных документов в документообороте */
export const GetDocuments = (params?: IParams) =>
  API.get(`/${C300}/models/documents/`, undefined, params);

/* Создание документа в документообороте */
export const CreateDocument = (data: IParams) =>
  API.gatewayPost(`/${C300}/models/documents/`, data);

/* Получение конкретного документа в документообороте */
export const GetDocument = (id: string) =>
  API.get(`/${C300}/models/documents/`, id);

/* Изменение документа в документообороте */
export const EditDocument = (id: string, data: IParams) =>
  API.gatewayPatch(`/${C300}/models/documents/`, id, data);

/* Удаление документа в документообороте */
export const RemoveDocument = (id: string) =>
  API.delete('/models/documents/', id);

/* Получение категорий */
export const GetCategories = () =>
  API.get(`/${C300}/models/document_categories/`);

/* Создание категории */
export const CreateCategory = (data: IParams) =>
  API.gatewayPost(`/${C300}/models/document_categories/`, data);

/* Удаление категории */
export const DeleteCategory = (id: string) =>
  API.delete('/models/document_categories/', id);

/* Получение тегов */
export const GetTags = () =>
  API.get(`/${C300}/models/document_tags/`);

/* Создание тега */
export const CreateTag = (data: IParams) =>
  API.gatewayPost(`/${C300}/models/document_tags/`, data);

/* Удаление тега */
export const DeleteTag = (id: string) =>
  API.delete('/models/document_tags/', id);

/* Добавление файлов к документу */
export const AddFile = (docId: string, data: FormData) =>
  API.postFiles(`/models/documents/${docId}/files/`, data);

/* Получение файла из документа */
export const GetFile = (docId: string, fileId: string) =>
  API.get(`/${C300}/models/documents/${docId}/files/`, fileId);

/* Переименование файла */
export const EditFile = (
  docId: string,
  fileId: string,
  params: { new_filename: string }
) =>
  API.gatewayPatch(
    `/${C300}/models/documents/${docId}/files/`,
    fileId,
    params
  );

/* Удаление файла */
export const RemoveFile = (docId: string, fileId: string) =>
  API.delete(`/models/documents/${docId}/files/`, fileId);

/* Получение количества документов распределенных по списку */
export const GetDocumentsQuantityByStatus = (params?: IParams) =>
  API.get(
    `/${C300}/models/documents/quantity_by_status/`,
    undefined,
    params
  );
